import React from "react";

const EmptyDataText = ({ text }) => {
  return <span className="sr-only">{text}</span>;
};

export default EmptyDataText;
